import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { useAuth, landingPath } from "@/context/AuthContext";
import { Ship } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, loadExec } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    const run = async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const { data } = await axios.post(
          `${API}/auth/session`,
          {},
          { headers: { "X-Session-ID": sessionId }, withCredentials: true }
        );
        setUser(data);
        const ex = await loadExec();
        const dest = landingPath(ex, data);
        window.history.replaceState(null, "", dest);
        navigate(dest);
      } catch {
        navigate("/login");
      }
    };
    run();
  }, [navigate, setUser, loadExec]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-navy gap-4">
      <Ship className="w-10 h-10 text-gold animate-pulse" />
      <p className="text-slate-300 text-sm">Signing you in…</p>
    </div>
  );
}
